import React, { useState } from 'react';
import './App.css';

// Import tất cả các components
import InfoPanel from './components/InfoPanel';
import LoginForm from './components/LoginForm';
import RegisterForm from './components/RegisterForm';
import ResetPasswordForm from './components/ResetPasswordForm';
import VerifyCodeForm from './components/VerifyCodeForm';
import WelcomeScreen from './components/WelcomeScreen';
import Dashboard from './components/Dashboard';
import SetupSpace from './components/SetupSpace';
import ConnectDevices from './components/ConnectDevices';
import LinkDevice from './components/LinkDevice';
import ConfirmSpace from './components/ConfirmSpace';
import SpaceMap from './components/SpaceMap';
import RoomDetail from './components/RoomDetail';
import DeviceDetail from './components/DeviceDetail';
import Statistics from './components/Statistics';
import Profile from './components/Profile';
import Members from './components/Members';
import ChatBot from './components/ChatBot';
import ToastContainer from './components/Toast';

function App() {
  const [view, setView] = useState('intro');
  const [showChatBot, setShowChatBot] = useState(false);

  // --- STATE MỚI QUẢN LÝ KẾT NỐI ---
  // Danh sách lưu trữ ID của các thiết bị đã kết nối thành công
  const [connectedDevices, setConnectedDevices] = useState([]);
  // Lưu trữ ID của thiết bị đang được thực hiện kết nối (khi chuyển sang màn hình LinkDevice)
  const [connectingDeviceId, setConnectingDeviceId] = useState(null);
  // State để quản lý xem đã setup space chưa
  const [hasSpace, setHasSpace] = useState(false);

  // --- CÁC HÀM ĐIỀU HƯỚNG (NAVIGATION HANDLERS) ---
  const handleStart = () => setView('login');
  const handleLoginSubmit = () => {
    // Kiểm tra đã đăng nhập chưa
    const isLoggedIn = localStorage.getItem('isLoggedIn');
    if (isLoggedIn === 'true') {
      setView('welcome'); // Chuyển đến WelcomeScreen trước
    } else {
      setView('verify');
    }
  };
  const handleRegister = () => setView('register');
  const handleBackToLogin = () => setView('login');
  const handleRegisterSuccess = () => {
    // Sau khi đăng ký thành công, chuyển đến WelcomeScreen
    setView('welcome');
  };
  const handleForgotPassword = () => setView('reset');
  const handleVerifySuccess = () => setView('welcome');
  const handleEnterDashboard = () => setView('dashboard'); // Hiển thị Dashboard (Spaces view)
  const handleSetupSpace = () => setView('setup');
  const handleContinueToDevices = () => setView('connect');
  const handleBackToSetup = () => setView('setup');
  const handleContinueToConfirm = () => setView('confirm');
  const handleBackToConnect = () => setView('connect');
  const handleViewSpaceMap = () => setView('space-map');
  const handleBackToDashboard = () => setView('dashboard');
  const [selectedRoom, setSelectedRoom] = useState('Living Room');
  const handleRoomClick = (roomName) => {
    setSelectedRoom(roomName);
    setView('room-detail');
  };
  const handleBackToSpaceMap = () => setView('space-map');
  const [selectedDevice, setSelectedDevice] = useState({ name: 'Speaker', room: 'Living room' });
  const handleDeviceClick = (deviceName, roomName) => {
    setSelectedRoom(roomName); // Cập nhật selectedRoom khi click vào device
    setSelectedDevice({ name: deviceName, room: roomName });
    setView('device-detail');
  };
  const handleBackToRoomDetail = () => {
    // Đảm bảo quay về đúng room của device hiện tại
    setView('room-detail');
  };
  const handleBackToDashboardFromDevice = () => setView('dashboard');

  // 10. CẬP NHẬT: Nhấn dấu (+) để kết nối thiết bị cụ thể
  const handleAddDeviceClick = (deviceId) => {
    setConnectingDeviceId(deviceId); // Lưu ID thiết bị đang muốn kết nối
    setView('link-device');
  };

  // 11. Từ trang Link Device -> Quay lại danh sách Connect (đã được định nghĩa ở trên)

  // 12. CẬP NHẬT: Xử lý khi hoàn tất kết nối từ trang LinkDevice
  const handleFinishLinking = (deviceId) => {
    // Nếu thiết bị này chưa có trong danh sách, thêm vào
    if (deviceId && !connectedDevices.includes(deviceId)) {
      setConnectedDevices(prev => [...prev, deviceId]);
    }
    // Quay lại màn hình danh sách thiết bị
    handleBackToConnect();
  };

  // 13. HÀM MỚI: Xử lý xóa thiết bị (Giả lập)
  const handleDeleteDevice = (deviceId, deviceName) => {
    if (window.confirm(`Are you sure you want to remove ${deviceName}?`)) {
      setConnectedDevices(prev => prev.filter(id => id !== deviceId));
    }
  };

  // 14. HÀM MỚI: Xử lý xóa member (Giả lập)
  const handleDeleteMember = (memberId, memberName) => {
    if (window.confirm(`Are you sure you want to remove ${memberName}?`)) {
      // Có thể thêm state để quản lý members nếu cần
      console.log(`Removed member: ${memberName}`);
    }
  };

  // 15. HÀM MỚI: Xử lý khi hoàn tất setup
  const handleFinishSetup = () => {
    setHasSpace(true); // Đánh dấu đã setup space
    setView('dashboard'); // Chuyển về Dashboard (Spaces view) với đầy đủ nội dung
  };

  const handleLogout = () => {
    // Clear all authentication data
    localStorage.removeItem('jwt_token');
    localStorage.removeItem('user');
    localStorage.removeItem('isLoggedIn');
    // Navigate to login page - this will trigger LoginForm reset via useEffect
    setView('login');
  };

  // Handler cho navigation từ Sidebar
  const handleNavClick = (navId) => {
    switch(navId) {
      case 'spaces':
        // Hiển thị Dashboard (Spaces view) khi nhấn Spaces
        setView('dashboard');
        break;
      case 'rooms':
        // Điều hướng đến room-detail với room mặc định
        setSelectedRoom('Living Room');
        setView('room-detail');
        break;
      case 'devices':
        // Điều hướng đến device-detail với Smart Socket mặc định ở Living Room
        setSelectedRoom('Living Room'); // Đảm bảo selectedRoom được cập nhật
        setSelectedDevice({ name: 'Smart Socket', room: 'Living Room' });
        setView('device-detail');
        break;
      case 'members':
        setView('members');
        break;
      case 'stats':
        setView('statistics');
        break;
      case 'profile':
        setView('profile');
        break;
      default:
        break;
    }
  };

  const showInfoPanel = ['intro', 'login', 'reset', 'verify'].includes(view);
  const isIntroView = view === 'intro';

  return (
    <div className="app-container">
      
      {showInfoPanel && (
        <InfoPanel isExpanded={isIntroView} onStart={handleStart} />
      )}

      <LoginForm 
        key={view === 'login' ? 'login-form' : 'login-form-hidden'}
        isVisible={view === 'login'} 
        onForgotPassword={handleForgotPassword} 
        onLoginSubmit={handleLoginSubmit}
        onRegister={handleRegister}
      />
      <RegisterForm 
        isVisible={view === 'register'} 
        onBackToLogin={handleBackToLogin}
        onRegisterSuccess={handleRegisterSuccess}
      />
      <ResetPasswordForm isVisible={view === 'reset'} onBackToLogin={handleBackToLogin} />
      <VerifyCodeForm isVisible={view === 'verify'} onVerifySuccess={handleVerifySuccess} onResend={() => alert("Mã mới đã được gửi!")} />
      <WelcomeScreen isVisible={view === 'welcome'} onGetStarted={handleEnterDashboard} />
      <Dashboard 
        isVisible={view === 'dashboard'} 
        onLogout={handleLogout} 
        onSetup={handleSetupSpace}
        hasSpace={hasSpace}
        connectedDevices={connectedDevices}
        onViewSpaceMap={handleViewSpaceMap}
        onNavClick={handleNavClick}
        onDeviceClick={handleDeviceClick}
        onOpenChatBot={() => setShowChatBot(true)}
      />
      <SetupSpace isVisible={view === 'setup'} onBack={() => setView('dashboard')} onContinue={handleContinueToDevices} onLogout={handleLogout} />

      {/* --- CẬP NHẬT ConnectDevices --- */}
      <ConnectDevices
        isVisible={view === 'connect'}
        onBack={handleBackToSetup}
        onContinue={handleContinueToConfirm}
        onLogout={handleLogout}
        onAddDevice={handleAddDeviceClick} // Truyền hàm thêm thiết bị
        connectedDevices={connectedDevices} // Truyền danh sách thiết bị đã kết nối
        onDeleteDevice={handleDeleteDevice} // Truyền hàm xóa thiết bị
      />

      {/* --- CẬP NHẬT LinkDevice --- */}
      <LinkDevice 
        isVisible={view === 'link-device'}
        onBack={handleBackToConnect}
        // Cập nhật: Nút Continue gọi hàm hoàn tất kết nối
        onContinue={handleFinishLinking}
        onLogout={handleLogout}
        // Truyền ID thiết bị đang được kết nối để hàm onContinue biết
        connectingDeviceId={connectingDeviceId}
      />

      {/* --- CẬP NHẬT ConfirmSpace --- */}
      <ConfirmSpace
        isVisible={view === 'confirm'}
        onBack={handleBackToConnect}
        onContinue={handleFinishSetup}
        onLogout={handleLogout}
        connectedDevices={connectedDevices}
        onDeleteDevice={handleDeleteDevice}
        onDeleteMember={handleDeleteMember}
      />

      {/* --- SpaceMap --- */}
      <SpaceMap
        isVisible={view === 'space-map'}
        onBack={handleBackToDashboard}
        onLogout={handleLogout}
        onRoomClick={handleRoomClick}
        onNavClick={handleNavClick}
      />

      {/* --- RoomDetail --- */}
      <RoomDetail
        isVisible={view === 'room-detail'}
        onBack={handleBackToSpaceMap}
        onLogout={handleLogout}
        roomName={selectedRoom}
        onDeviceClick={handleDeviceClick}
        onNavClick={handleNavClick}
      />

      {/* --- DeviceDetail --- */}
      <DeviceDetail
        isVisible={view === 'device-detail'}
        onBack={handleBackToRoomDetail}
        onLogout={handleLogout}
        deviceName={selectedDevice.name}
        roomName={selectedDevice.room}
        onNavClick={handleNavClick}
      />

      {/* --- Statistics --- */}
      <Statistics
        isVisible={view === 'statistics'}
        onBack={handleBackToDashboard}
        onLogout={handleLogout}
        onNavClick={handleNavClick}
      />

      {/* --- Profile --- */}
      <Profile
        isVisible={view === 'profile'}
        onBack={handleBackToDashboard}
        onLogout={handleLogout}
        onNavClick={handleNavClick}
      />

      {/* --- Members --- */}
      <Members
        isVisible={view === 'members'}
        onBack={handleBackToDashboard}
        onLogout={handleLogout}
        onNavClick={handleNavClick}
      />

      {/* --- ChatBot - Luôn hiển thị khi đã đăng nhập (ở mọi trang) --- */}
      {(() => {
        const isLoggedIn = localStorage.getItem('isLoggedIn') === 'true';
        const isPreLoginView = ['intro', 'login', 'register', 'reset', 'verify', 'welcome'].includes(view);
        return isLoggedIn && !isPreLoginView;
      })() && (
        <ChatBot
          isVisible={true}
          onClose={() => {}} // Không cần đóng nữa
          onLogout={handleLogout}
        />
      )}

      {/* Toast Notifications */}
      <ToastContainer />

    </div>
  );
}

export default App;